/** Event colors offered in the editor (the app's own palette). */
export const EVENT_COLORS: Array<{ name: string; hex: string }> = [
  { name: "Vermelho", hex: "#e5484d" },
  { name: "Coral", hex: "#f2777a" },
  { name: "Laranja", hex: "#f76b15" },
  { name: "Âmbar", hex: "#e2a336" },
  { name: "Verde", hex: "#30a46c" },
  { name: "Floresta", hex: "#18794e" },
  { name: "Céu", hex: "#0090ff" },
  { name: "Azul", hex: "#3e63dd" },
  { name: "Lilás", hex: "#8e8cd8" },
  { name: "Violeta", hex: "#8e4ec6" },
  { name: "Cinza", hex: "#6f6e77" }
];

/** Calendars get the same palette plus a few extra tones. */
export const CALENDAR_COLORS = [
  ...EVENT_COLORS.map((c) => c.hex),
  "#d6409f",
  "#ef8a2c",
  "#d5ae39",
  "#65a30d",
  "#12a594",
  "#5b8def",
  "#b197fc",
  "#a1795a"
];

/** Default calendar color (same as the backend's). */
export const DEFAULT_COLOR = "#0090ff";

export const HOLIDAY_COLOR = "#18794e";

export function colorName(hex: string | null | undefined): string {
  return EVENT_COLORS.find((c) => c.hex.toLowerCase() === hex?.toLowerCase())?.name ?? "";
}
